import React from 'react';
import { connect } from 'react-redux';
import { Typography } from '@mui/material';
import { createActions } from '../store';
import TextInformationDialog from '../../../dialogs/TextInformationDialog';

const WebGLContextLossAlertDialog = (props) => {
    const { webGLContextLossAlertDialogOpen, setProperty } = props;
    const onClose = () => setProperty('webGLContextLossAlertDialogOpen', false);

    return (
        <TextInformationDialog
            title='Preview Error'
            open={webGLContextLossAlertDialogOpen}
            onClose={onClose}
        >
            <Typography>
                There was an error playing the preview. 
                Save your changes and refresh the page to restore the video preview. 
                If you keep seeing this error, you can go to preview settings (bottom right gear icon) and change the Video Background setting to PAUSE. 
                This will pause the video background and prevent this error from occurring. 
                The video background will be paused while editing, but it will be animated in your export.
            </Typography>
        </TextInformationDialog>
    );
};

const mapStateToProps = (state) => {
    const { webGLContextLossAlertDialogOpen } = state.create;
    return { webGLContextLossAlertDialogOpen };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(createActions.setProperty(key, value));
    return { setProperty }
}

export default connect(mapStateToProps, mapDispatchToProps)(WebGLContextLossAlertDialog);